import React from "react"
import { type GuestInformationStepProps } from "./shared"
import GuestInformationStepDesktop from "./desktop"
import GuestInformationStepMobile from "./mobile"

const GuestInformationStep: React.FC<GuestInformationStepProps> = (props) => {
  if (props.mobileSheet) {
    return <GuestInformationStepMobile {...props} />
  }
  return <GuestInformationStepDesktop {...props} />
}

export default GuestInformationStep
